import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/MANAGE_PLAN/EDIT_WEEKDAYS';

export const {action: editPlanWeekday} = createAction(`${domain}/EDIT_PLAN_WEEKDAY`, (planPart, day) => ({
    planPart,
    day,
}));

export const {action: close} = createAction(`${domain}/CLOSE`, () => ({}));

export const {action: savePlanWeekday} = createAction(`${domain}/SAVE_PLAN_WEEKDAY`, planPart => ({planPart}));

export const {action: sessionBookingChanged} = createAction(
    `${domain}/SESSION_BOOKING_CHANGED`,
    (session, add, bookingId) => ({session, add, bookingId}),
);

export const {action: updateSessionBookingTimes} = createAction(
    `${domain}/UPDATE_SESSION_TIMES`,
    (bookingId, start, end) => ({
        bookingId,
        start,
        end,
    }),
);

export const {action: removeSessionBooking} = createAction(`${domain}/REMOVE_SESSION_BOOKING`, bookingId => ({
    bookingId,
}));

export const {action: productBookingChanged} = createAction(`${domain}/PRODUCT_BOOKING_CHANGED`, (product, amount) => ({
    product,
    amount,
}));

export const {action: toggleSessionsShown} = createAction(`${domain}/TOGGLE_SESSIONS_SHOWN`, showSessions => ({
    showSessions,
}));
